import { ThemeNames } from '@interfaces/themes';
import { ICON_SETS } from '@themes/IconSets';
import IMAGES_SETS from '@themes/ImagesSets';

export const DEFAULT_THEME = ThemeNames.default as const;

export type IconName = keyof (typeof ICON_SETS)['default'];
export type ImageName = keyof (typeof IMAGES_SETS)['default'];
